const ones = ['', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة']
const teens = ['عشرة', 'أحد عشر', 'اثنا عشر', 'ثلاثة عشر', 'أربعة عشر', 'خمسة عشر', 'ستة عشر', 'سبعة عشر', 'ثمانية عشر', 'تسعة عشر']
const tens = ['', '', 'عشرون', 'ثلاثون', 'أربعون', 'خمسون', 'ستون', 'سبعون', 'ثمانون', 'تسعون']
const hundreds = ['', 'مائة', 'مائتان', 'ثلاثمائة', 'أربعمائة', 'خمسمائة', 'ستمائة', 'سبعمائة', 'ثمانمائة', 'تسعمائة']

function convertBelow1000(n) {
  if (n === 0) return ''
  if (n < 10) return ones[n]
  if (n < 20) return teens[n - 10]
  if (n < 100) {
    const unit = n % 10
    const ten = Math.floor(n / 10)
    if (unit === 0) return tens[ten]
    return `${ones[unit]} و${tens[ten]}`
  }
  const hundred = Math.floor(n / 100)
  const rest = n % 100
  if (rest === 0) return hundreds[hundred]
  return `${hundreds[hundred]} و${convertBelow1000(rest)}`
}

function convertInteger(n) {
  if (n === 0) return 'صفر'
  const parts = []
  const scales = [
    { value: 1_000_000_000, label: 'مليار' },
    { value: 1_000_000, label: 'مليون' },
    { value: 1000, label: 'ألف' },
  ]
  let remaining = n
  scales.forEach((scale, index) => {
    const count = Math.floor(remaining / scale.value)
    if (count > 0) {
      if (count === 1 && scale.label === 'ألف') {
        parts.push('ألف')
      } else if (count === 2 && scale.label === 'ألف') {
        parts.push('ألفان')
      } else if (count >= 3 && count <= 10 && scale.label === 'ألف') {
        parts.push(`${convertBelow1000(count)} آلاف`)
      } else {
        parts.push(`${convertBelow1000(count)} ${scale.label}`)
      }
      remaining %= scale.value
    }
    if (remaining > 0 && index === scales.length - 1) {
      parts.push(convertBelow1000(remaining))
    }
  })
  if (parts.length === 0) return convertBelow1000(n)
  return parts.join(' و')
}

export default function numberToArabicWords(amount, currency = 'جنيه') {
  const num = Number(amount)
  if (Number.isNaN(num)) return ''
  const integerPart = Math.floor(Math.abs(num))
  const fraction = Math.round((Math.abs(num) - integerPart) * 100)
  let result = convertInteger(integerPart)
  if (currency) {
    result += ` ${currency}`
  }
  if (fraction > 0) {
    result += ` و${convertInteger(fraction)} قرش`
  }
  return `${result} لا غير`
}
